// import React from "react";
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider, HashRouter, createHashRouter } from "react-router-dom";
import Home from "./../views/Home";
import Login from "../views/Login";
import AdminHome from "../views/admin/AdminHome";
import UserHome from "../views/clients/UserHome/UserHome";
import Dashboard from "../views/clients/Dashboard";
import Emitidos from "../views/clients/Emitidos";
import Recibidos from "../views/clients/Recibidos";
import Aprobacion from "../views/clients/Aprobacion";
import Clientes from "../views/admin/Clientes";
import Autorizacion from "../views/admin/Autorizacion";
import EnviarData from "../views/admin/EnviarData";
import Perfil from "../views/User/Perfil";
import Configuracion from "../views/User/Configuracion";
import AprobacionNueva from "../views/clients/Aprobaciones/AprobacionNueva";
import AprobacionesRealizadas from "../views/clients/Aprobaciones/AprobacionesRealizadas";
import AprobacionesRecibida from "../views/clients/Aprobaciones/AprobacionesRecibida";
import Page404 from "../components/Page404";
import ClientsData from "../views/admin/ClientsAdmin/ClientsData";
import CertificatesView from "../views/admin/CertificatesView";

export default function RoutesPath() {

    const router = createBrowserRouter(
        createRoutesFromElements(
        <Route errorElement={<Page404 />}>
            <Route path = "/" element = { <Home /> } />
            <Route path = "/home" element = { <Home /> } />
            <Route path = "/login" element = { <Login /> } />
            {/* testing */}
            <Route path = "/adminhome" element = { <AdminHome /> } />
            <Route path = "/userhome" element = { <UserHome /> } />
            {/* clientes */}
            <Route path = "/dashboard" element = { <Dashboard /> } />
            <Route path = "/resumen" element = { <Dashboard /> } />
            <Route path = "/emitidos" element = { <Emitidos /> } />
            <Route path = "/recibidos" element = { <Recibidos /> } />
            {/* <Route path = "/aprobacion" element = { <Aprobacion /> } /> */}
            <Route path = "/aprobacion" >
                <Route index element = { <Aprobacion/> } />
                <Route path = "/aprobacion/nueva" element = { <AprobacionNueva/> } />
                <Route path = "/aprobacion/realizadas" element = { <AprobacionesRealizadas/> } />
                <Route path = "/aprobacion/recibidas" element = { <AprobacionesRecibida/> } />
            </Route>
            {/* administracion */}
            <Route path = "/clientes" element = { <Clientes /> } />
            <Route path = "/clientes/data/:id" element = { <ClientsData /> } />
            <Route path = "/autorizacion" element = { <Autorizacion /> } />
            <Route path = "/enviardata" element = { <EnviarData /> } />
            {/* Usuarios */}
            <Route path = "/perfil" element = { <Perfil /> } />
            <Route path = "/configuracion" element = { <Configuracion /> } />
        </Route>
        ), { basename: '' }
    );

    const router2 = createHashRouter(
        createRoutesFromElements(
        <Route errorElement={<Page404 />}>
            <Route path = "/" element = { <Home /> } />
            <Route path = "/home" element = { <Home /> } />
            <Route path = "/login" element = { <Login /> } />
            {/* testing */}
            <Route path = "/adminhome" element = { <AdminHome /> } />
            <Route path = "/userhome" element = { <UserHome /> } />
            {/* clientes */}
            <Route path = "/dashboard" element = { <Dashboard /> } />
            <Route path = "/resumen" element = { <Dashboard /> } />
            <Route path = "/emitidos" element = { <Emitidos /> } />
            <Route path = "/recibidos" element = { <Recibidos /> } />
            {/* <Route path = "/aprobacion" element = { <Aprobacion /> } /> */}
            <Route path = "/aprobacion" >
                <Route index element = { <Aprobacion/> } />
                <Route path = "/aprobacion/nueva" element = { <AprobacionNueva/> } />
                <Route path = "/aprobacion/realizadas" element = { <AprobacionesRealizadas/> } />
                <Route path = "/aprobacion/recibidas" element = { <AprobacionesRecibida/> } />
            </Route>
            {/* administracion */}
            <Route path = "/clientes" element = { <Clientes /> } />
            <Route path = "/clientes/data/:id" element = { <ClientsData /> } />
            <Route path = "/certificates" element = { <CertificatesView /> } />
            <Route path = "/autorizacion" element = { <Autorizacion /> } />
            <Route path = "/enviardata" element = { <EnviarData /> } />
            {/* Usuarios */}
            <Route path = "/perfil" element = { <Perfil /> } />
            <Route path = "/configuracion" element = { <Configuracion /> } />
        </Route>
        ), { basename: '' }
    );

    // const Router2 = ();

    return (
        <div>
            <RouterProvider router={router2} />
        </div>
    );
}